export const fundingSourceCodeMap: any = {
  // 'payment-buttons_paypal': 'paypal.FUNDING.PAYPAL',
  'payment-buttons_venmo': 'paypal.FUNDING.VENMO',
  'payment-buttons_paylater': 'paypal.FUNDING.PAYLATER',
  'payment-buttons_credit': 'paypal.FUNDING.CARD',
  'payment-buttons_card': 'paypal.FUNDING.CARD',
}

export const fundingSource: any = {
  // 'payment-buttons_paypal': 'paypal',
  'payment-buttons_venmo': 'venmo',
  'payment-buttons_paylater': 'paylater',
  'payment-buttons_card': 'card',
}

export const fundingOrderMap = [
  // 'paypal.FUNDING.PAYPAL',
  'paypal.FUNDING.PAYLATER',
  'paypal.FUNDING.VENMO',
  'paypal.FUNDING.CARD',
]

export const getSelectedSources = (selectedPaymentButtons: any) =>
  Object.keys(fundingSourceCodeMap)
    .map((fundingSource) => {
      if (selectedPaymentButtons.includes(fundingSource)) {
        return fundingSourceCodeMap[fundingSource]
      }
      return null
    })
    .filter(Boolean)

export const parseSelectedSources = (
  params: any,
  selectedButtons: string[],
) => {
  return fundingOrderMap
    .filter(
      (fundingSource) =>
        selectedButtons.includes(fundingSource) &&
        (params.paymentModel === 'recurring'
          ? fundingSource !== 'paypal.FUNDING.VENMO'
          : true),
    )
    .filter(
      (fundingSource) =>
        params.options.find((option: any) => option.name === 'integration')
          .value === 'standard' || fundingSource !== 'paypal.FUNDING.CARD',
    )
    .map((fundingSource) =>
      fundingSource.replace('paypal.FUNDING.', '').toLowerCase(),
    )
    .join(',')
}

export const getUnselectedSources = (selectedSources: string[]) =>
  Object.keys(fundingSourceCodeMap).filter(
    (fundingSource) =>
      !selectedSources.includes(fundingSourceCodeMap[fundingSource]),
  )

export const parseUnselectedSources = (
  params: any,
  unselectedButtons: string[],
) => {
  return fundingOrderMap
    .filter(
      (fundingSource) =>
        unselectedButtons
          .map((unselectedButton: string) =>
            unselectedButton
              .toUpperCase()
              .replace('PAYMENT-BUTTONS_', 'paypal.FUNDING.'),
          )
          .includes(fundingSource) &&
        (params.paymentModel === 'recurring'
          ? fundingSource !== 'paypal.FUNDING.VENMO'
          : true),
    )
    .filter(
      (fundingSource) =>
        params.options.find((option: any) => option.name === 'integration')
          .value === 'standard' || fundingSource !== 'paypal.FUNDING.CARD',
    )
    .map((fundingSource) =>
      fundingSource.replace('paypal.FUNDING.', '').toLowerCase(),
    )
    .join(',')
}
